import { render } from "./GMSerializationModal.vue?vue&type=template&id=1cb3fcc8"
import script from "./GMSerializationModal.vue?vue&type=script&lang=js"
export * from "./GMSerializationModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Products/GMWorkFlow/GMSerializationModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1cb3fcc8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1cb3fcc8', __exports__)) {
    api.reload('1cb3fcc8', __exports__)
  }
  
  module.hot.accept("./GMSerializationModal.vue?vue&type=template&id=1cb3fcc8", () => {
    api.rerender('1cb3fcc8', render)
  })

}


export default __exports__